module.exports = React.createClass
  componentDidMount: ->
    @spinner = new Spinner(@props.options ? {}).spin(@refs.spinnerEl.getDOMNode())

  componentWillUnmount: ->
    @spinner.stop()

  render: ->
    <div className='spinner-el' ref='spinnerEl'/>
